module.exports = __webpack_public_path__ + "static/media/about.31aac2d6.jpeg";